<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Player, { VimeoEmbedParameters } from '@vimeo/player'


const props = withDefaults(
  defineProps<{
    config: VimeoEmbedParameters
  }>(),
  {
    config: () => ({
      autoplay: false,
      controls: true,
      responsive: true,
      muted: false,
      title: false,
      byline: false,
      portrait: false,
    }),
  }
)

const containerRef = ref<HTMLDivElement | null>(null)
const player = ref<Player | null>(null)

onMounted(() => {
  if (!containerRef.value) return

  try {
    // Create player instance with the provided URL and config
    player.value = new Player(containerRef.value, props.config)

    // Set volume to 0 if muted
    if (props.config?.muted) {
      player.value.setVolume(0)
    }

    // Add play event listener for debugging/tracking
    player.value.on('play', () => {
      console.log('Video player started:', props.config?.url)
    })

    // Add error event listener
    player.value.on('error', (error: Error) => {
      console.error('Vimeo player error:', error)
    })
  } catch (error) {
    console.error('Failed to initialize Vimeo player:', error)
  }
})
</script>

<template>
  <div
    ref="containerRef"
    class="vimeo-player-container"
    :style="{
      maxWidth: config?.width ? `${config.width}px` : '100%'
    }"
  />
</template>

<style scoped>
.vimeo-player-container {
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  background-color: #000;
  padding: 8px;
}

:deep(iframe) {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
